<template>
  <div class="captcha" id="captcha"></div>
</template>

<script>
import Utils from "../Utils";

export default {
  name: "ReCaptcha_v2",
  mixins: [Utils],
  mounted() {
    const component = this;
    window.grecaptcha.render('captcha', {
      'sitekey': '6LfyD2AaAAAAAEn0PE2I_Xvya-1VvCmlaz4eCEQK',
      'callback': function (response){
        component.$store.commit("app/setCaptcha", response);
      }
    });
  }
}
</script>

<style scoped>
  .captcha{
    margin: 0.5rem 0;
  }
</style>